export const isLogged = ({ auth }) => ({
  isLogged: !!auth.isLogged
})